module.exports = __webpack_public_path__ + "static/ClimateView-a8c789bfdcee8661a848e5289464d3ae.jpg";